import * as React from "react";

function SvgIcTrash(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 4a2 2 0 012-2h6a2 2 0 012 2v2h3a1 1 0 110 2h-1v12a2 2 0 01-2 2H7a2 2 0 01-2-2V8H4a1 1 0 010-2h3V4zm2 2V4h6v2H9zM7 8v12h10V8H7zm3 2a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zm5 1a1 1 0 10-2 0v6a1 1 0 102 0v-6z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcTrash;
